import _ from 'underscore';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

/**
 * Rebuild tree structure using parsed text that represents the structure
 * Helper function, will not be exported through index
 * @param {array} nameList - parsed text that represents the structure
 * @param {object} tree - json object used to keep track of and store tree structure
 * @param {object} data - current node being processed, used to
 * maintain the original structure
 * @returns {object} parsed tree
 */
export function parseTree(nameList, tree, data) {
  let currentTree = tree;

  for (let nameIdx = 0; nameIdx < nameList.length; nameIdx += 1) {
    let matchingNode = null;

    // search for node matching current name
    for (let nodeIdx = 0; nodeIdx < currentTree.length; nodeIdx += 1) {
      if (nameList[nameIdx] === currentTree[nodeIdx].name) {
        matchingNode = currentTree[nodeIdx];
        break;
      }
    }

    // create new node with name if cannot find matching one
    if (_.isNull(matchingNode)) {
      matchingNode = {
        id: generateGuid(),
        name: nameList[nameIdx],
        children: [],
        data: null,
      };

      currentTree.push(matchingNode);
    }

    // bind data to node if the node is a leaf node
    if (nameIdx === (nameList.length - 1)) {
      matchingNode.data = data;
    }

    // keep searching the children of matching node
    currentTree = matchingNode.children;
  }

  return tree;
}

/**
 * Parse a json object based on given schema
 * @param {object} dataList - the original data usually in a flat list
 * @param {object} schema - indicate which field to looking for and the delimeter being used here
 * @returns {object} parsed tree
 */
export function jsonTreeParse(dataList, schema) {
  let tree = [];

  if (!_.isString(schema.field) || !_.isString(schema.delimeter)
      || _.isEmpty(schema.field) || _.isEmpty(schema.delimeter)) {
    return tree;
  }

  const delimeterRegex = new RegExp(`[^${schema.delimeter}]+`, 'g');
  const treeNameField = schema.field;

  for (let i = 0; i < dataList.length; i += 1) {
    const data = dataList[i];

    if (!_.isString(data[treeNameField])) {
      return tree;
    }

    const nameList = data[treeNameField].match(delimeterRegex);

    tree = parseTree(nameList, tree, data);
  }

  return tree;
}
